export class BranchPinEntity {
  id?: number
  branchId?: number
  branchName?: string | null
  order?: number
}
